import Vue from 'vue';
import VTooltip from 'v-tooltip';
import BaoRecipe from './components/recipe';
import ListResult from './components/list-result';
import TextsStore from './srores/text-store';

Vue.use(VTooltip);

export const debug = true;

export default new Vue();

export const app = new Vue({

    'el' : '#app',

    'components': {
        BaoRecipe,
        ListResult
    },

    created() {
        TextsStore.loadTexts();
    }

});